import React from 'react';
import propTypes from 'prop-types';
import Markdown from 'markdown-to-jsx';

const { string } = propTypes;

export const MagicMarkdown = ({ children }) => {

  return (
    <Markdown
      options={{
        overrides: {
          // eslint-disable-next-line id-length
          a: {
            component: 'a',
            props: {
              className: 'sui-underline sui-break-all',
              target: '_parent'
            },
          },
          ol: {
            props: { className: 'sui-list-decimal' }
          },
          ul: {
            props: { className: 'sui-list-disc' }
          },
          li: {
            props: {
              className: 'sui-mb-1 sui-ml-5 sui-list-outside'
            }
          },
        },
      }}
    >
      {children.replaceAll(/\n\n/g, '\n\n &nbsp; \n\n')}
    </Markdown>
  );
};

MagicMarkdown.propTypes = {
  children: string,
};

MagicMarkdown.defaultProps = {
  children: '',
};
